import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getDeviceInteraction } from '@gameday/utils/selectors/getDeviceInteraction';
import {
    PositionWrapper,
    PlayerLink
} from '../BoxscoreTeamTable.style';
import PlayerNameWithNote from './PlayerNameWithNote';
import types from './config/BoxscoreTypes';
import { getContextData } from '@gameday/utils/selectors/getContextData';
import buildPlayerUrl from '@gameday/utils/buildPlayerUrl';
const { PITCHING } = types;

const PlayerLinkWrapper = (props) => {
    const { deviceInteraction } = useSelector(getDeviceInteraction);
    const { playerFullName, note, label, type, playerId, language } = props;
    const getPlayerContextData = useSelector(getContextData);
    const { disablePlayerLinks, playerPageContext } = getPlayerContextData(playerId);
    const playerUrl = buildPlayerUrl({ nameSlug: playerId, language, playerPageContext });

    const handlePlayerPage = useCallback((e) => {
        if (deviceInteraction.playercard({ title: 'Player Card', url: playerUrl, pid: playerId })) {
            e.preventDefault();
            return false;
        }
    }, [deviceInteraction, playerUrl, playerId]);

    const handlers = useMemo(() => ({
        onClick: handlePlayerPage
    }), [handlePlayerPage]);

    return (
        !disablePlayerLinks
            ? <>
                <PlayerLink url={playerUrl} target={'_blank'} ariaLabel={playerFullName} handlers={handlers} className={type === PITCHING ? 'pitcherLink' : ''}>
                    <PlayerNameWithNote player={label} note={note} type={type} />
                </PlayerLink>
            </>
            : <PlayerNameWithNote player={label} note={note} type={type} />
    );
};

PlayerLinkWrapper.propTypes = {
    data: PropTypes.shape({
        displayPositions: PropTypes.string,
        playerUrl: PropTypes.string,
        playerFullName: PropTypes.string,
        note: PropTypes.string,
        player: PropTypes.string,
        type: PropTypes.string,
        language: PropTypes.string,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default PlayerLinkWrapper;
